import React from 'react';
import Header from '../../components/header';
import PricingBody from './body';
import Footer from '../../components/footer';

function Pricing(props) {
    document.title = `Yebokenny Pricing Plans`;
    return (
        <div>
            <Header></Header>
            <PricingBody></PricingBody>
            <Footer></Footer>
        </div>
    );
}

export default Pricing;